import React from "react";
const Arrow = (props) => {
  return (
    <svg
      {...props}
      width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99953 8.80062C8.29953 8.80062 7.59953 8.53063 7.06953 8.00063L0.549531 1.48062C0.259531 1.19062 0.259531 0.710625 0.549531 0.420625C0.839531 0.130625 1.31953 0.130625 1.60953 0.420625L8.12953 6.94062C8.60953 7.42062 9.38953 7.42062 9.86953 6.94062L16.3895 0.420625C16.6795 0.130625 17.1595 0.130625 17.4495 0.420625C17.7395 0.710625 17.7395 1.19062 17.4495 1.48062L10.9295 8.00063C10.3995 8.53063 9.69953 8.80062 8.99953 8.80062Z" fill="#292D32" />
    </svg>

  )
}

export default Arrow;